import { deleteRequest, getRequest, patchRequest, postRequest } from '@utils/axios/baseRequests'
import { getClientById } from '@utils/clientsUtils'
import saveStreamableFile from '@utils/saveStreamableFile'
import { concatParams } from '@utils/urlManipulation'
import { IObj } from 'shared/types/common'
import { IPresentation } from 'shared/types/presentation.type'
import { Config, GIGAPRES_URL, ONITY_URL, PRES_URL, USERS_URL } from '@const/url'

export const PRES_LIMIT = 50

const normalizeDataToSend = (data: IObj<any>) => {
  return { ...data, client: data.client?._id || '' }
}
export const normalizeDataToSave = (
  data: IPresentation,
  clients: Record<string, string>
): IPresentation => {
  if (data.client && typeof data.client === 'string') {
    data.client = getClientById(data.client, clients)
  }
  return data
}

export const getPresAll = async (params?: IObj<any>) => {
  try {
    const concatedParams = concatParams(
      Object.assign(params || {}, {
        //sort: 'updatedAt',
        fields: ['presName', 'client', 'owner', 'isCombo', 'createdAt', 'updatedAt'].join('%2C'),
        limit: PRES_LIMIT,
      })
    )
    const result = await getRequest(`${PRES_URL}?${concatedParams}`)
    return result.data
  } catch (err) {
    console.log('Не удалось получить список презентаций', err)
    return []
  }
}

export const getPresById = async (id: string) => {
  try {
    const result = await getRequest(`${PRES_URL}/${id}`)
    return result.data
  } catch (err) {
    console.log('Не удалось получить данные презентации', err)
    return {}
  }
}

export const getAllClientsNames = async () => {
  try {
    const result = await getRequest(`${ONITY_URL}/clients`)
    return result.data
  } catch (err) {
    console.log('Не удалось получить список клиентов', err)
    return []
  }
}

export const getPresClientsNames = async () => {
  try {
    const result = await getRequest(`${ONITY_URL}/clientsFiltered`)
    return result.data
  } catch (err) {
    console.log('Не удалось получить список клиентов', err)
    return []
  }
}

export const getAppUsersNames = async () => {
  try {
    const result = await getRequest(`${USERS_URL}/all`)
    return result.data
    //return result.data.map((user: any) => `${user.firstName} ${user.lastName}`)
  } catch (err) {
    console.log('Не удалось получить список пользователей', err)
    return []
  }
}

export const importPresentation = async (presData: IObj<any>) => {
  const { presName, client, status, googleSheet } = presData
  const dataToSend = {
    presentationsLinks: [],
    globalPresName: presName,
    client,
    status,
    spreadsheetId: googleSheet.substring(googleSheet.indexOf('/d/') + 3).split('/')[0],
  }
  try {
    const response = await postRequest(
      `${GIGAPRES_URL}/import`,
      {},
      normalizeDataToSend(dataToSend)
    )
    return response.data
  } catch (err) {
    console.log('Не удалось импортировать презентацию', err)
    return null
  }
}

export const createPresentation = async (dataToSend: IObj<any>) => {
  try {
    const response = await postRequest(PRES_URL, {}, normalizeDataToSend(dataToSend))
    return response.data
  } catch (err) {
    console.log('Не удалось создать презентацию', err)
  }
}

export const updatePresentation = async (presId: string, dataToSend: IObj<any>) => {
  delete dataToSend.__v
  try {
    const response = await patchRequest(
      `${PRES_URL}/${presId}`,
      {},
      normalizeDataToSend(dataToSend)
    )
    return response.data
  } catch (err) {
    console.log('Не удалось обновить презентацию')
  }
}

export const toggleIsPresentationFavorite = async (presId: string, isFavorite: boolean) => {
  try {
    const response = await postRequest(
      `${PRES_URL}/${presId}/favorite`,
      {},
      {
        isFavorite,
      }
    )
    return response.data
  } catch (err) {
    console.log('Не удалось обновить избранное')
  }
}

export const copyPresentation = async (presId: string) => {
  try {
    const response = await postRequest(`${PRES_URL}/${presId}/copy`, {})
    return response.data
  } catch (err) {
    console.log('Не удалось скопировать презентацию')
  }
}

export const reconstructPresentation = async (presId: string) => {
  try {
    const response = await getRequest(`${PRES_URL}/${presId}/reconstruct`)
    return response.data
  } catch (err) {
    console.log('Не удалось восстановить презентацию')
  }
}

export const updatePresentationPreviews = async (presId: string, file: File) => {
  try {
    const fileName = file.name.split('.')[0].replace('-thumb', '')

    const formData = new FormData()

    formData.append('slideName', fileName)
    formData.append('preview', file)

    const result = await patchRequest(
      `${PRES_URL}/${presId}/previews`,
      Config.MULTIPART_HEADERS,
      formData
    )

    if (result) {
      return result.data
    }
  } catch (err) {
    console.log('Не удалось создать превью')
  }
}

export const deletePresentation = async (presId: string) => {
  try {
    const response = await deleteRequest(`${PRES_URL}/${presId}`)
    return response.data
  } catch (err) {
    console.log('Не удалось удалить презентацию')
  }
}

export const exportPresentation = async (presId: string) => {
  try {
    const response = await getRequest(`${PRES_URL}/${presId}/pres_config`)
    saveStreamableFile(response.data, 'pres_config')
    return response
  } catch (err) {
    console.log('Не удалось скачать конфиг')
  }
}
